import { FC } from 'react'

import { DetailsGrid } from '@ui/drawer/common/DetailsGrid'

import { AssetInfoBase } from '../assetInfoBase'
import { AssetInfoDomain } from '../assetInfoDomain'
import { AssetInfoMail } from '../assetInfoMail'
import { TechnologiesInfo } from '../technologiesInfo'
import { AssetInfoWrapper } from './assetInfo.styles'

type TAssetInfoProps = {
    asset: TAsset
}

const AssetInfo: FC<TAssetInfoProps> = ({ asset }) => {
    const { asset_type: assetType } = asset

    return (
        <AssetInfoWrapper className="asset-info">
            <DetailsGrid dataTestId="asset-details-grid">
                <AssetInfoBase asset={asset} />
                {assetType === 'email' ? (
                    <AssetInfoMail asset={asset} />
                ) : (
                    <AssetInfoDomain asset={asset} />
                )}
            </DetailsGrid>
            <TechnologiesInfo asset={asset} />
        </AssetInfoWrapper>
    )
}

export default AssetInfo
